<style scoped>
.news_report {
  width: 1000px;
  margin: 30px auto;
  background-color: #fff;
}
.title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 25px;
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  position: relative;
}
.title-fl {
  padding-left: 15px;
}
.title-fr {
  padding-right: 15px;
}
.title-fl,
.title-fr {
  flex: 1;
}
.title-fr {
  position: absolute;
  bottom: 5px;
  right: 0;
  height: 30px;
  text-align: right;
  font-size: 15px;
}
.title-fr:hover {
  cursor: pointer;
  color: red;
}
.desc {
  padding: 10px 0;
}
.desc img {
  width: 450px;
  height: 240px;
}
ul {
  padding-left: 60px;
  box-sizing: border-box;
}
ul li a {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 40px;
  line-height: 40px;
}
.description {
  width: 100%;
  display: flex;
}
.abstract {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.date {
  width: 100px;
}
ul li a:hover {
  color: red;
}
</style>
<template>
  <div class="news_report">
    <div class="title">
      <div class="title-fl">龍之超头条</div>
      <div class="title-fr">
        <router-link to="/news"><Icon type="ios-arrow-forward" size="25" /></router-link>
      </div>
    </div>
    <div class="desc">
      <Row>
        <i-col span="10">
          <div class="pic" style="width: 450px; height: 240px">
            <Carousel autoplay :autoplay-speed="speed" arrow="never">
              <!-- dots="outside" -->
              <Carousel-item v-for="(item, index) in newsBanner" :key="index">
                <img :src="item" alt @click="clickImg(item)" />
              </Carousel-item>
            </Carousel>
          </div>
        </i-col>
        <i-col span="14">
          <div class="news">
            <ul>
              <li v-for="item in newsList" :key="item.newsId">
                <a :href="item.link" target="_blank">{{ item.title }}</a>
                <div class="description">
                  <div class="abstract">{{ item.description }}</div>
                  <div class="date">{{ item.date }}</div>
                </div>
              </li>
            </ul>
          </div>
        </i-col>
      </Row>
    </div>
    <imgBox
      v-if="showImg"
      :img="imgPath"
      :showImg="showImg"
      @closeImg="closeImg"
    />
  </div>
</template>

<script>
import imgBox from "components/img/ImgBox";
import axios from "axios";
import { rangeData } from "static/common.js";
export default {
  components: {
    imgBox,
  },
  data() {
    return {
      speed: 5000,
      showImg: false,
      imgPath: "",
      newsList: [],
      newsBanner: [],
    };
  },
  methods: {
    clickImg(e) {
      this.imgPath = e;
      this.showImg = true;
    },
    closeImg(e) {
      this.showImg = e;
    },
    reqNewsList() {
      axios.get("./data.json").then((res) => {
        this.newsList = rangeData(res.data.newsList).splice(0, 4);
      });
    },
    reqBannerList() {
      axios.get("./data.json").then((res) => {
        this.newsBanner = res.data.articleBannerList;
      });
    },
  },
  mounted() {
    this.reqNewsList();
    this.reqBannerList();
  },
};
</script>


